import React, { useState,forwardRef,useRef,useImperativeHandle, useEffect } from 'react';
import { ApiRequest,UrlParams, DownloadFile, PreviewFile } from 'library/APICall';
import { uuidv4, AddEvent_ALT } from 'library/Library';
import useLoader from 'hooks/useLoader';
import Loader from 'layout/loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTrash, faDownload, faTimes, faSpinner, faEye } from '@fortawesome/free-solid-svg-icons';
import { HideModal } from 'layout/modal/Modal';
import useDeepEffect from 'hooks/useDeepEffect';
import { ShowSnackbar, ResponseSnackbar } from 'layout/snackbar/Snackbar';
import { FormStyle } from 'layout/select/Style';
import Select from 'react-select';

/**
 * This function is called to only view attachments no operation.
 */
export function ShowAttachments({attachmentIds, showOnPopUp = true, forceReload = false}){

    //This stores all prev uploaded and recently uploaded files.
    const [files,setFiles]=useState([]);
    

    const [attachmentId,setAttachmentId]=useState(attachmentIds);
    const [attachmentUI,setAttachmentUI]=useState(<></>);
    const [forceReloadState, setForceReloadState] = useState(false)

    const ref_attachments=useRef();

    //Attachment UI Loader Here,
    const [setLoaderStatus,loading,isLoading] = useLoader();
    

    //This function gets all files detail based on attachmentId array.
    const GetFilesDetail=()=>{
        
        if(attachmentId.length==0){
            setFiles([])
            return;
        }
        var obj={
            ids:attachmentId.toString()
        };
        ApiRequest({ TYPE:'GET', URL:'/app/Files/GetFiles?'+UrlParams(obj), 
        CALLBACK:function(res){
            if(res.error_code=="0"){
                if(res.data.files.length>0){
                    setFiles(res.data.files);//Adding individual files to the array.
                }
            }
        }, 
        COMPLETE:function(){}, 
        DATA:{} })
    }

    useDeepEffect(()=>{
        GetFilesDetail();
    },[attachmentId, forceReloadState,attachmentIds]);

    useDeepEffect(() => {
        setAttachmentId(attachmentIds)
    }, [attachmentIds])

    useDeepEffect(() => {
        setForceReloadState(forceReload)
    }, [forceReload])
    
    var FileUploadList=()=>{
        var tr=[];
        files.forEach((x,index)=>{
            tr.push(
                <tr key={x.id}>
                    <td style={{verticalAlign:'middle'}}>{index+1}</td>
                    <td style={{verticalAlign:'middle', wordWrap:"break-word"}}>{x.file_name}</td>
                    <td style={{verticalAlign:'middle'}}>{x.file_type_name}</td>
                    <td style={{verticalAlign:'middle'}}>
                    <button
                className="as-btn-text"
                title="View File"
                onClick={() => {
                  var obj = {
                    q: x.download_path,
                    file_extension: x.file_extension,
                  };
                  if (
                    obj.file_extension == ".pdf" ||
                    obj.file_extension == ".jpg" ||
                    obj.file_extension == ".jpeg" ||
                    obj.file_extension == ".png" ||
                    obj.file_extension == ".gif"
                  ) {
                    PreviewFile(obj);
                  } else {
                    ShowSnackbar("error", `Cannot preview file with extension ${obj.file_extension}.`);
                  }
                }}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>

                        <button
                            className="as-btn-text"
                            title='Download File'
                            onClick={()=>{
                                var obj={
                                    q:x.download_path,
                                    file_extension:x.file_extension
                                }
                                DownloadFile(obj)
                            }}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                        </button>
                    </td>
                </tr>
            );
        });
        return tr;
    }

    var FileUploadUI=()=>{
        
        return (
            <>
                <table className="as-table as-table-bordered as-table-striped as-table-small-text" style={{tableLayout:'fixed'}}>
                    <thead>
                        <tr>
                            <th style={{width:"5%"}}>#</th>
                            <th style={{width:"50%"}}>File Name</th>
                            <th style={{width:"20%"}}>File Type</th>
                            <th style={{width:"25%"}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {FileUploadList()}
                    </tbody>
                </table>
            </>
        )
    }

    const id="Modal_"+uuidv4();


    return (
        <>
            {
                showOnPopUp
                ?
                    <>
                        <div className="as-modal-body">
                            {FileUploadUI()}
                        </div>
                        
                        <div className="as-modal-footer">
                            <button type="button" className="as-btn as-btn-small" onClick={()=>HideModal()}>Close</button>
                        </div>
                    </>
                :
                    FileUploadUI()
            }
        </>

    );

}
/**
 * This will accept following parameters as props.
 * @attachmentIds AttachmentId array that is already inserted. It must be passed blank array if not required.
* allowed_format:if this prop is null then any format of file is allowed to upload but if it include array like ['png','jpeg'] then it will only allow those file        format only
*number_of_files: if it is null limit is not set to validate the upload files but if contain any value like 1,2 then more then number of files we cannot upload.
 */
const Attachments=forwardRef(( {attachmentIds=[], contextProvider=null, showOnRender=false, showOnPopUp=true, showPreview=false, showFooterAction=false, footerAction, extraButton = <></>,allowed_format= [], number_of_files = null, show_close_button=true,footer_action=null, onlySingleAttachment=false}, ref ) =>{
console.log('attachmentIds', attachmentIds)
    useImperativeHandle(ref, ()=>{
        return {
            show: () => {return show},//Used to know display status of attachment ui.
            setShow:setShow,//Used to show or hide attachment ui.
            isUploading:isUploading,//Use to know if files are still uploading
            getAttachmentId:getAttachmentId,//Get attachment id to be sent for insert/update
            closeModal: () => setShow(false),
            resetFiles:(x)=>GetFilesDetail(x)
        };
    });

    //Show or hide attachment ui.
    const [show,setShow]=useState(showOnRender);

    //This stores all prev uploaded and recently uploaded files.
    const [files,setFiles]=useState([]);
    

    const [attachmentId,setAttachmentId]=useState(attachmentIds);
    const [attachmentUI,setAttachmentUI]=useState(<></>);

    const ref_attachments=useRef();

    const [ddl,setDDL]=useState({
        ddlAttachment:[]
    });

    useEffect(()=>{
        setLoaderStatus('loadddl',true);
        ApiRequest({ TYPE:'GET', URL:'/app/Files/loadddl', CALLBACK:function(res){
            setDDL({
                ddlAttachment:res.data.file_type
            })
        }, COMPLETE:function(){
            setLoaderStatus('loadddl',false);
        }, DATA:{} });
    },[attachmentId]);

    //Attachment UI Loader Here,
    const [setLoaderStatus,loading,isLoading] = useLoader();
    

    //This function gets all files detail based on attachmentId array.
    const GetFilesDetail=(new_attachmentId=attachmentId)=>{
        
        if(!new_attachmentId || new_attachmentId.length==0){
            setFiles([])
            return;
        }
        var obj={
            ids:new_attachmentId.toString()
        };
        ApiRequest({ TYPE:'GET', URL:'/app/Files/GetFiles?'+UrlParams(obj), 
        CALLBACK:function(res){
            if(res.error_code=="0"){
                if(res.data.files.length>0){
                    setFiles(res.data.files);//Adding individual files to the array.
                }
            }
        }, 
        COMPLETE:function(){}, 
        DATA:{} })
    }

    useDeepEffect(()=>{
        GetFilesDetail();
    },[attachmentId]);

    useDeepEffect(()=>{
        setAttachmentUI(
            //TODO: Attachments UI
        );
    },[files]);

    useDeepEffect(() => {
        setAttachmentId(attachmentIds)
    }, [attachmentIds])


    //This function returns all attachment id of uploaded file.
    const getAttachmentId=()=>{
        return files.map(x=>x.id);
    }

    //This function returns if files are still in uploading state.
    const isUploading=()=>{
        return isLoading();
    }

    var updateName = (e,id) =>{
        var value=e.target.value;
        setFiles(files=>{
            var oldFiles=JSON.parse(JSON.stringify(files));
            var index=oldFiles.findIndex(thatFile=>thatFile.id==id);
            oldFiles[index].file_name=value;
            return oldFiles;
        });
    }

    var updateFileType = (e,id) =>{
        var value=e.value;
        setFiles(files=>{
            var oldFiles=JSON.parse(JSON.stringify(files));
            var index=oldFiles.findIndex(thatFile=>thatFile.id==id);
            oldFiles[index].file_type_id=value;
            return oldFiles;
        });
    }
    
    console.log(allowed_format.length)
    var FileUploadList=()=>{
        //debugger;
        var tr=[];
        files.forEach((x,index)=>{
            

            
            tr.push(
                <tr key={x.id}>
                    <td style={{verticalAlign:'middle'}}>
                        {index+1}
                    </td>
                    <td style={{verticalAlign:'middle'}}>
                        <input 
                            key={"input_"+x.id}
                            type="text" 
                            className="as-form-component" 
                            value={x.file_name || ""}
                            onChange={e => {
                                updateName(e, x.id);
                            }}

                            onBlur={e=>{
                                
                                if(e.target.value==""){
                                    return;
                                }
                                var obj={
                                    id:x.id,
                                    name:e.target.value
                                }
                                setLoaderStatus('attach_file',true);
                                ApiRequest({ TYPE:'POST', URL:'/app/Files/UpdateName?'+UrlParams(obj), CALLBACK:function(res){
                                }, COMPLETE:function(){
                                    setLoaderStatus('attach_file',false);
                                }, DATA:{} });
                            }}
                        />
                    </td>
                    <td style={{verticalAlign:'middle'}}>
                        <Select closeMenuOnSelect={true}
                            className="select-component"
                            styles = {FormStyle()}
                            id = {"file_type_"+index}
                            name = {"file_type_"+index}
                            placeholder = "File Type"
                            options = {ddl.ddlAttachment}
                            onChange={e=>{
                                    updateFileType(e,x.id);
                                    var obj={
                                        id:x.id,
                                        file_type_id:e.value
                                    }
                                    setLoaderStatus('attach_file',true);
                                    ApiRequest({ TYPE:'POST', URL:'/app/Files/UpdateFileType?'+UrlParams(obj), CALLBACK:function(res){
                                    }, COMPLETE:function(){
                                        setLoaderStatus('attach_file',false);
                                    }, DATA:{} });
                                }
                            }   
                            value = {
                                ddl.ddlAttachment.filter(da=>da.value==x.file_type_id).length>0?
                                ddl.ddlAttachment.filter(da=>da.value==x.file_type_id)[0]:null
                            }
                        />
                    </td>
                    <td style={{verticalAlign:'middle'}}>
                    <button
                className="as-btn-text"
                title="View File"
                onClick={() => {
                  var obj = {
                    q: x.download_path,
                    file_extension: x.file_extension,
                  };
                  if (
                    obj.file_extension == ".pdf" ||
                    obj.file_extension == ".jpg" ||
                    obj.file_extension == ".jpeg" ||
                    obj.file_extension == ".png" ||
                    obj.file_extension == ".gif"
                  ) {
                    PreviewFile(obj);
                  } else {
                    ShowSnackbar("error", `Cannot preview file with extension ${obj.file_extension}.`);
                  }
                }}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>

                        <button
                            className="as-btn-text"
                            title='Download File'
                            onClick={()=>{
                                var obj={
                                    q:x.download_path,
                                    file_extension:x.file_extension
                                }
                                DownloadFile(obj)
                            }}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                        </button>
                        <button
                            className="as-btn-text-red"
                            title='Trash'
                            onClick={()=>{
                                //Delete file from array.
                                setFiles(files=>{
                                    var oldFiles=JSON.parse(JSON.stringify(files));
                                    var index=oldFiles.findIndex(thatFile=>thatFile.id==x.id);
                                    oldFiles.splice(index,1);
                                    return oldFiles;
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </td>
                </tr>
            );
        });
        return tr;
    }

    var FileUploadUI=()=>{
        
        return (
            <>
                {
                    (
                        isLoading()==false
                        ?(<label htmlFor="upload-files" className="choose-input">Click here to add attachments...</label>)
                        :(<label className="choose-input" title="Please Wait! Files are uploading.">
                            <span className="upload-animation">UPLOADING...</span>
                        </label>)
                    )
                }
                    

                <input
                    type="file"
                    name="photo"
                    id="upload-files"
                    multiple
                    className="input-file-attachment"
                    onChange={(e)=>{
                        // e.target.files.length;
                        debugger
                        const selectedFiles = Array.from(e.target.files);

                        if(e.target.value == '')
                            return

                        if (number_of_files != null && (selectedFiles.length + files.length > number_of_files)) {
                            e.target.value = '';
                            ShowSnackbar('error', `You can upload a maximum of ${number_of_files} files.`);
                            return;
                        }

                        var formData = new FormData();
                        var files_information=[];
                        
                        //if file is uploading for signature and profile image it should be "png".
                        if (onlySingleAttachment) {
                            const file = selectedFiles[0]; // Always one file for signature and profile image
                            const fileExt = (file.name.split('.').pop() || '').toLowerCase().trim();

                            if (fileExt !== 'png') {
                                e.target.value = '';
                                ShowSnackbar("error", "Please upload only PNG file format.");
                                return;
                            }
                        }

                        const invalidFileFound = selectedFiles.some(file => {
                        const fileExt = (file.name.split('.').pop() || '').toLowerCase().trim();
                        if (allowed_format.length > 0 && !allowed_format.includes(fileExt)) {
                            return true; 
                        }
                            return false;
                        });

                        if (invalidFileFound) {
                            e.target.value = '';  
                                const formatsList = allowed_format.join(', ');
                                ShowSnackbar("error", `Please Upload valid file format: ${formatsList}.`);
                            return;
                        }


                        for(var i=0;i<e.target.files.length;i++){
                            var element=e.target.files[i];
                            formData.append('files[]', element);
                            files_information.push({
                                file_name:element.name
                            });
                        }
                        e.target.value = ''
                        formData.append("files_information",JSON.stringify(files_information));

                        setLoaderStatus("attach_files",true);

                        ApiRequest({ TYPE:'POST', URL:'/app/Files/upload', CALLBACK:function(res){
                            if(res.error_code=="1"){
                                ShowSnackbar('error','File attachment process failed.');
                                return;
                            }
                            if(res.error_code=="2"){
                                ResponseSnackbar(res);
                                return;
                            }
                            ShowSnackbar('success','File attached.');
                            res.data.uploaded_files.forEach(x=>{
                                setFiles(p=>[...p,x]);
                            });
                            
                        }, COMPLETE:function(){
                            setLoaderStatus("attach_files",false);
                        }, DATA:formData })
                    }}
                />

                <br/>
                <table className="as-table as-table-bordered as-table-striped as-table-small-text">
                    <thead>
                        <tr>
                            <th width="1%">#</th>
                            <th width="50%">File Name</th>
                            <th width="20%">File Type</th>
                            <th  width="29%">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {FileUploadList()}
                    </tbody>
                </table>
            </>
        )
    }

    //  -------------------------------------------------------------------------------------
    //  Action on Keyboard Shortcuts
    // useEffect(() => {
        
    //     var saveAndClose = AddEvent_ALT('e', () => {
    //         if(isLoading()) {
    //             return
    //         } else {
    //             setShow(false)
    //             if(showFooterAction) {
    //                 footerAction()
    //             }
    //         }
    //     })

    //     return () => {
    //         saveAndClose()
    //     }
    // })
    //  -------------------------------------------------------------------------------------

    const id="Modal_"+uuidv4();

    if(!show){
        return (<></>);
    }

    return (
        <>
        
            {loading(true)}

            {
                showOnPopUp
                ?
                    <div id={id} className='as-modal-popup-wrapper as-attachment-modal' style={{display:"block"}}>
                        <div className={`as-modal-popup as-small-modal-popup`}>
                            {/* <span
                                className="as-close-modal-popup"
                                title='Save & Close'
                                onClick={()=>{
                                    if(isLoading()) {
                                        return
                                    } else {
                                        setShow(false)
                                        if(showFooterAction) {
                                            footerAction()
                                        }
                                    }
                                }}
                            >
                                {
                                    isLoading()
                                    ?
                                        <FontAwesomeIcon icon={faSpinner} className='as-rotate' />
                                    :
                                        <FontAwesomeIcon icon={faTimes} />
                                }
                            </span> */}
                            <div className='as-modal-popup-header'>

                                {show_close_button && (
                                    <button className={`as-close-modal-popup  as-small-modal-popup`} onClick={()=>{
                                        if(isLoading()) {
                                            return
                                        } else {
                                            setShow(false)
                                            if(showFooterAction) {
                                                footerAction()
                                            }
                                        }
                                    }}>
                                    <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                )}
                                <span className="as-modal-popup-header ">Attach Files</span>
                            </div>
                            <div className="as-modal-popup-body">
                                {FileUploadUI()}
                            </div>

                            {footer_action !==null && (
                                <div>
                                    {footer_action}
                                </div>
                            )}

                            <div className={`as-modal-popup-footer as-text-right`}>
                                <button
                                    type="button"
                                    className="as-default-btn-solid"
                                    onClick={()=>{
                                        if(isLoading()) {
                                            return
                                        } else {
                                            setShow(false)
                                            if(showFooterAction) {
                                                footerAction()
                                            }
                                        }
                                    }}
                                    disabled={isLoading()}
                                >
                                    Save & Close
                                </button>
                                {extraButton}
                                {}
                            </div>
                        </div>
                    </div>
                :
                    <div id={id} style={{display:"block"}}>
                        {FileUploadUI()}
                    </div>
            }
            
        </>
    );

    

    
    //setAttachmentId is used to set attachment id for the first time in update case. it is used to retrive all attachments.
    //attachmentUI is the place where we upload and see attachements.
    //getAttachmentId is where we get latest attachment id for update/insert operation.
    //isUploading returns true if the files are in uploading state. It must be checked in insert/update.
    //return [setAttachmentId,attachmentUI,getAttachmentId,isUploading];
});

export default Attachments;
